// extracted by mini-css-extract-plugin
export var animatedDesktop = "BulletsCard-module--animatedDesktop--1be8d";
export var card = "BulletsCard-module--card--4cc99";
export var count = "BulletsCard-module--count--2b9d9";
export var countDescription = "BulletsCard-module--countDescription--5c081";
export var countNumWrap = "BulletsCard-module--countNumWrap--6aa15";
export var description = "BulletsCard-module--description--a765e";
export var descriptionWrapper = "BulletsCard-module--descriptionWrapper--ff817";
export var fadeInAnimation = "BulletsCard-module--fadeInAnimation--b6bee";